import(/* webpackMode: "eager" */ "/builds/partnership/promo/landing-pages/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Ubuntu\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"300\",\"400\",\"500\",\"700\"],\"display\":\"swap\"}],\"variableName\":\"ubuntu\"}");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/builds/partnership/promo/landing-pages/src/app/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GdprFlag"] */ "/builds/partnership/promo/landing-pages/src/components/cookie-consent/GdprFlag.tsx");
;
import(/* webpackMode: "eager" */ "/builds/partnership/promo/landing-pages/src/global.css");
